import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LPService} from "./services/lp.service";
import {ReplaceStringPipe} from "./pipes/replace-string.pipe";
import {UtilsService} from "./services/utils.service";


@NgModule({
	declarations: [ReplaceStringPipe],
	imports: [
		CommonModule
	],
	providers: [LPService, UtilsService],
	exports: [ReplaceStringPipe]
})
export class SharedModule {
}
